exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#model-tree[data-v-5586a79e]{background-color:transparent}[data-v-5586a79e] .el-loading-mask{height:calc(100% - 42px);background-color:rgba(0,0,0,.5)!important}", ""]);

// exports
